import Vue from 'vue';

import uiComponents from 'js-ui/js/bootstrap/components/admin';

export default function() {

    // Core
    Vue.component('core-icon', require('js-core/js/components/Icon.vue').default);
    Vue.component('core-spinner', require('js-core/js/components/Spinner.vue').default);

    // UI
    uiComponents();

    // App

}
